export enum RenderingErrorCodes {
    INTERVALS = 'INTERVALS',
    FIELD = 'FIELD',
    DEFAULT_COLOR = 'DEFAULT_COLOR',
    INTERVALS_OVERLAP = 'INTERVALS_OVERLAP',
    COLORS = 'COLORS',
    APPLICATION_FIELD = 'FIELD_ID',
    DUPLICATE_INTERVAL = 'DUPLICATE_INTERVAL'
}
